import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-tc-accordion',
  templateUrl: './tc-accordion.component.html',
  styleUrls: ['./tc-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TcAccordionComponent implements OnInit {
  content$: Observable<any> = this.component.data$;
  collapsedHeight = '56px';
  expandedHeight = '56px';

  constructor(public component: CmsComponentData<any>) {}

  ngOnInit() {}
}
